import { toLonLat } from 'ol/proj';
import { getlayerByName, setFloatingControlsVisible, closeSidebarOnMobile } from './CustomFunctions';
import { map } from './Map';
import { MAP_PROJECTION_CODE, GEOSERVER_EXTERNAL_URL, GEOSERVER_BASE_URL } from './Config';
import Overlay from 'ol/Overlay';
import { toStringHDMS } from 'ol/coordinate';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import CircleStyle from 'ol/style/Circle';
import BottomSheet from './BottomSheet';


// ✅ Initialize the Floating Bottom Sheet
const featureSheet = new BottomSheet();

// Make featureSheet globally accessible for other scripts
window.featureSheet = featureSheet;

// ✅ Define Actions for Identify Tool
const IDENTIFY_ACTIONS = [
  { id: 'hide', icon: 'fa-solid fa-eye-slash', class: 'secondary', title: 'إخفاء مؤقت' },
  { id: 'report', icon: 'fa-solid fa-image', label: 'تقرير', class: 'primary', title: 'تصدير صورة JPG' },
  { id: 'zoom', icon: 'fa-solid fa-magnifying-glass-plus', class: 'secondary', title: 'تكبير على القطعة' },
  { id: 'streetview', icon: 'fa-solid fa-street-view', class: 'secondary', title: 'Street View' }
];

// Special Actions for Buildings (No Report)
const BUILDING_ACTIONS = [
  { id: 'hide', icon: 'fa-solid fa-eye-slash', class: 'secondary', title: 'إخفاء مؤقت' },
  { id: 'zoom', icon: 'fa-solid fa-magnifying-glass-plus', class: 'secondary', title: 'تكبير على المبنى' },
  { id: 'streetview', icon: 'fa-solid fa-street-view', class: 'secondary', title: 'Street View' }
];

// ⚡ Legacy Popup Removed - Using BottomSheet Only
// The 'overlay' code block (lines 22-45) was removed to prevent conflicts.
// The BottomSheet component now handles all feature info display.


// ✅ إنشاء طبقة التحديد الزرقاء المميزة (Premium Highlight) - Identify Tool
const identifyidentifyHighlightSource = new VectorSource();
const premiumHighlightStyle = [
  // Outer glow (thick, low opacity)
  new Style({
    stroke: new Stroke({ color: 'rgba(0, 123, 255, 0.3)', width: 8 }),
    image: new CircleStyle({
      radius: 10,
      stroke: new Stroke({ color: 'rgba(0, 123, 255, 0.3)', width: 6 }),
    })
  }),
  // Inner core (thin, solid)
  new Style({
    stroke: new Stroke({ color: 'rgba(0, 123, 255, 1)', width: 3 }),
    fill: new Fill({ color: 'rgba(0, 123, 255, 0.15)' }),
    image: new CircleStyle({
      radius: 6,
      fill: new Fill({ color: 'rgba(0, 123, 255, 0.15)' }),
      stroke: new Stroke({ color: 'rgba(0, 123, 255, 1)', width: 2 })
    })
  })
];

const identifyidentifyHighlightLayer = new VectorLayer({
  source: identifyidentifyHighlightSource,
  style: premiumHighlightStyle,
  zIndex: 9999
});
// Attach to window so TopSearch can clear it
window.identifyidentifyHighlightSource = identifyidentifyHighlightSource;
map.addLayer(identifyidentifyHighlightLayer);

/* =====================================================
   زر عائم لإظهار نافذة المعلومات (بدون غطاء fullscreen)
   ===================================================== */
(function ensureParcelInfoShowChip() {
  // ✅ تأكد من عدم إنشاء الزر مرتين
  if (document.getElementById('parcelInfoShowChipBtn')) return;

  const btn = document.createElement('button');
  btn.id = 'parcelInfoShowChipBtn';
  btn.className = 'parcel-info-chip'; // ⚡ Match exempt selector in BottomSheet
  btn.type = 'button';
  btn.innerHTML = `<i class="fas fa-info-circle"></i> إظهار المعلومات`;
  btn.style.cssText = `
    display: none;
    position: fixed;
    z-index: 3001;
    bottom: calc(env(safe-area-inset-bottom, 0px) + 90px);
    left: 50%;
    transform: translateX(-50%);
    align-items: center;
    gap: 10px;
    cursor: pointer;
    background: var(--gradient-primary, linear-gradient(135deg, #dc3545, #b61e2a));
    color: #fff;
    border: none;
    border-radius: 50px;
    padding: 14px 24px;
    font-size: 0.95rem;
    font-weight: 600;
    box-shadow: 0 8px 30px rgba(220,53,69,.35), 0 4px 12px rgba(0,0,0,.15);
    transition: all 0.3s ease;
    -webkit-transform: translateX(-50%);
    will-change: transform;
    touch-action: manipulation;
  `;

  // Hover effect
  btn.addEventListener('mouseenter', () => {
    btn.style.transform = 'translateX(-50%) translateY(-3px)';
    btn.style.boxShadow = '0 12px 40px rgba(220,53,69,.45), 0 6px 16px rgba(0,0,0,.2)';
  });
  btn.addEventListener('mouseleave', () => {
    btn.style.transform = 'translateX(-50%)';
    btn.style.boxShadow = '0 8px 30px rgba(220,53,69,.35), 0 4px 12px rgba(0,0,0,.15)';
  });

  document.body.appendChild(btn);

  btn.addEventListener('click', () => { showParcelInfo(); });
})();

// ✅ دوال إظهار/إخفاء الزر
function showParcelInfoChip() {
  const btn = document.getElementById('parcelInfoShowChipBtn');
  if (btn) btn.style.display = 'flex';
}
function hideParcelInfoChip() {
  const btn = document.getElementById('parcelInfoShowChipBtn');
  if (btn) btn.style.display = 'none';
}

/* =====================================================
   حالة آخر نافذة معلومات حتى نسترجعها عند "إظهار"
   ===================================================== */
let lastParcelHTML = '';
let lastParcelCoord = null;  // إحداثيات وضع الـoverlay
let lastParcelFeature = null; // لتأكيد أن هناك تحديد قائم

// Multi-Feature Navigation State
let identifiedFeatures = [];
let currentFeatureIndex = 0;

/**
 * دالة مساعدة لتحويل بيانات القطعة الخام إلى تنسيق الـ BottomSheet
 */
function buildParcelSheetData(parcel) {
  const plotNo = parcel.plot_no || parcel.PLOT_NO || '-';
  const blockNo = parcel.block_no || parcel.BLOCK_NO || '-';
  const blockName = parcel.block_a || parcel.BLOCK_A || '';
  const village = parcel.village_a || parcel.VILLAGE_A || '';
  const governorate = parcel.gov_a || parcel.GOV_A || '';

  // Badge Logic
  let badgeType = 'c';
  const classification = (parcel.landclas_l || parcel.landclas_1 || parcel.LandClas_1 || '').toString().toUpperCase();
  if (classification.includes('A')) badgeType = 'a';
  else if (classification.includes('B')) badgeType = 'b';
  else if (classification.includes('C')) badgeType = 'c';

  // Area Calculations
  const rawArea = parcel.area || parcel.Area;
  const areaSqM = rawArea ? parseFloat(rawArea) : null;
  const areaDunam = areaSqM ? (areaSqM / 1000).toFixed(3) : null;
  const areaSqMStr = areaSqM ? `${areaSqM.toFixed(2)} م²` : '-- م²';
  const areaDunamStr = areaDunam ? `${areaDunam} دونم` : '-- دونم';

  return {
    title: `قطعة ${plotNo}`,
    subtitle: `حوض ${blockNo}${blockName ? ' - ' + blockName : ''} | ${village} | ${governorate}`,
    status: {
      label: parcel.landclas_l || parcel.landclas_1 || parcel.LandClas_1 || 'غير محدد',
      type: badgeType
    },
    keyMetric: {
      label: 'المساحة',
      value: areaDunamStr,
      icon: 'fa-ruler-combined'
    },
    attributes: [
      { key: 'المحافظة', value: governorate || '-' },
      { key: 'التجمع', value: village || '-' },
      { key: 'رقم الحوض', value: blockNo },
      { key: 'اسم الحوض', value: blockName || '-' },
      { key: 'اسم الحي', value: parcel.quarternam || parcel.QuarterNam || '-' },
      { key: 'رقم الحي', value: parcel.quarternum || parcel.QuarterNum || '-' },
      { key: 'رقم القطعة', value: plotNo },
      { key: 'المساحة', value: areaSqMStr },
      { key: 'التقسيم الجيوسياسي', value: parcel.landclas_l || parcel.landclas_1 || parcel.LandClas_1 || '-' },
      { key: 'المخطط الهيكلي', value: (parcel.plan || parcel.Plan || '-') === '-' ? 'لا يوجد مخطط هيكلي' : (parcel.plan || parcel.Plan) },
      { key: 'نوع المخطط', value: parcel.plan_type_ || parcel.PLAN_TYPE_ || '-' },
      { key: 'نوع الأرض', value: parcel.plot_type || parcel.PLOT_TYPE || '-' },
      { key: 'نوع الصخور', value: parcel.rock_type_ || parcel.ROCK_TYPE_ || '-' },
      { key: 'رطوبة التربة', value: parcel.moisture_c || parcel.MOISTURE_C || '-' },
      { key: 'الخدمات', value: parcel.road_acces || parcel.ROAD_ACCES || '-' },
      { key: 'متوسط الانحدار', value: parcel.slope_mean || parcel.Slope_Mean ? `${parseFloat(parcel.slope_mean || parcel.Slope_Mean).toFixed(1)}°` : '-' },
      { key: 'الارتفاع', value: (parcel.elv || parcel.Elv) ? `<span style="direction:ltr;display:inline-block;">${parcel.elv || parcel.Elv}</span>` : '-' },
      { key: 'ملاحظات', value: parcel.notes || parcel.NOTES || '-' }
    ].filter(attr => attr.value !== '-' && attr.value !== null)
  };
}

/**
 * دالة مساعدة لتحويل بيانات الحوض الطبيعي إلى تنسيق الـ BottomSheet
 */
function buildBlocksNonRegisteredSheetData(block) {
  const blockNo = block.blocknumbe || '-';
  const blockName = block.blockname_ || '';
  const community = block.communityn || '';
  const governorate = block.governorat || '';

  // Area Calculations
  const rawArea = block.area || block.shape_area;
  const areaSqM = rawArea ? parseFloat(rawArea) : null;
  const areaDunam = areaSqM ? (areaSqM / 1000).toFixed(3) : null;
  const areaSqMStr = areaSqM ? `${areaSqM.toFixed(2)} م²` : '-- م²';
  const areaDunamStr = areaDunam ? `${areaDunam} دونم` : '-- دونم';

  return {
    title: `حوض طبيعي ${blockNo}`,
    subtitle: `${blockName ? blockName + ' - ' : ''}${community} | ${governorate}`,
    keyMetric: {
      label: 'المساحة',
      value: areaDunamStr,
      icon: 'fa-ruler-combined'
    },
    attributes: [
      { key: 'المحافظة', value: governorate || '-' },
      { key: 'التجمع', value: community || '-' },
      { key: 'رقم الحوض', value: blockNo },
      { key: 'اسم الحوض', value: blockName || '-' },
      { key: 'المساحة (م²)', value: areaSqMStr },
      { key: 'المساحة (دونم)', value: areaDunamStr }
    ].filter(attr => attr.value !== '-' && attr.value !== null)
  };
}

/**
 * دالة مساعدة لتحويل بيانات المبنى إلى تنسيق الـ BottomSheet
 */
function buildBuildingSheetData(building) {
  const postalCode = building.postal_cod || building.POSTAL_COD || '-';
  const community = building.communityn || building.COMMUNITYN || '';
  const governorate = building.governorat || building.GOVERNORAT || '';
  
  const rawArea = building.area || building.Area || building.shape_area || building.Shape_Area;
  const areaSqM = rawArea ? parseFloat(rawArea).toFixed(2) : '-';

  return {
    title: `مبنى - رمز بريدي: ${postalCode}`,
    subtitle: community || governorate ? `${community}${community && governorate ? ' | ' : ''}${governorate}` : (postalCode !== '-' ? `الرمز البريدي الرسمي للمبنى` : 'بيانات المبنى الجغرافي'),
    keyMetric: {
      label: 'المساحة',
      value: areaSqM !== '-' ? `${areaSqM} م²` : '-- م²',
      icon: 'fa-building',
      color: '#17a2b8'
    },
    attributes: [
      { key: 'المحافظة', value: governorate || '-' },
      { key: 'التجمع', value: community || '-' },
      { key: 'الرمز البريدي', value: postalCode },
      { key: 'المساحة (م²)', value: areaSqM !== '-' ? `${areaSqM} م²` : '-' },
      { key: 'ID المبنى', value: building.fid || building.id || building.FID || '-' }
    ].filter(attr => attr.value !== '-' && attr.value !== null)
  };
}

/**
}

/**
 * دالة مساعدة لتحويل بيانات المعالم المستوردة (KML/DXF) إلى تنسيق الـ BottomSheet
 */
function buildImportedSheetData(feature) {
  const props = feature.getProperties();
  const name = props.name || props.Name || 'معلم مستورد';
  const desc = props.description || props.Description || '';

  const attributes = Object.entries(props)
    .filter(([k]) => k !== 'geometry' && k !== 'name' && k !== 'Name' && k !== 'description' && k !== 'Description')
    .map(([k, v]) => ({ key: k, value: (v || '').toString() }));

  return {
    title: name,
    subtitle: desc || 'بيانات من ملف خارجي',
    attributes: attributes
  };
}

// ✅ إغلاق الـ Popup مع إزالة التحديد (سلوك زر X)
// ✅ إغلاق الـ Popup مع إزالة التحديد (سلوك زر X)
// ⚡ Legacy Closer Logic Removed - Handled by BottomSheet actions mostly
// We keep a simple global closer function just in case legacy HTML buttons trigger it.


// دالة "إخفاء" تُغلق النافذة فقط وتُبقي التحديد وتُظهر زر الإظهار العائم
function hideParcelInfo() {
  if (lastParcelFeature) {
    if (typeof hidePopup === 'function') hidePopup();
    if (window.featureSheet) window.featureSheet.hide();
    showParcelInfoChip();
  }
}

// ✅ دالة "إظهار" تُرجع النافذة كما كانت - Using BottomSheet
function showParcelInfo() {
  const lastState = window._lastActiveSheetData;

  if (lastState && lastState.data) {
    featureSheet.clearCallbacks();
    setupIdentifyActions();

    let actionsToUse = IDENTIFY_ACTIONS; // Default for parcels

    if (lastState.isUrban) {
      actionsToUse = [
        { id: 'hide', icon: 'fa-solid fa-eye-slash', class: 'secondary', title: 'إخفاء' },
        { id: 'zoom', icon: 'fa-solid fa-magnifying-glass-plus', class: 'secondary', title: 'تكبير' }
      ];
    } else if (lastState.isBuilding) {
      actionsToUse = BUILDING_ACTIONS;
    } else if (lastState.isImported) {
      actionsToUse = [
        { id: 'hide', icon: 'fa-solid fa-eye-slash', class: 'secondary', title: 'إخفاء' },
        { id: 'zoom', icon: 'fa-solid fa-magnifying-glass-plus', class: 'secondary', title: 'تكبير' }
      ];
    }

    featureSheet.show({ ...lastState.data, actions: actionsToUse });

    ensureSidebarVisible();
    hideParcelInfoChip();
  }
}

/**
 * دالة مركزية لعرض 피처 محدد من القائمة بناءً على الـ index
 */
function showIdentifiedFeature(index) {
  if (!identifiedFeatures || identifiedFeatures.length === 0) return;
  
  // Constrain index
  if (index < 0) index = 0;
  if (index >= identifiedFeatures.length) index = identifiedFeatures.length - 1;
  currentFeatureIndex = index;
  
  const entry = identifiedFeatures[index];
  const { type, properties, geometry, coordinate, originalFeature, projection } = entry;
  
  let sheetData = null;
  let actionsToUse = [];
  
  // 1. Build Data based on Type
  if (type === 'Parcel') {
    sheetData = buildParcelSheetData(properties);
    actionsToUse = IDENTIFY_ACTIONS;
  } else if (type === 'Building') {
    sheetData = buildBuildingSheetData(properties);
    actionsToUse = BUILDING_ACTIONS;
  } else if (type === 'NaturalBlock') {
    sheetData = buildBlocksNonRegisteredSheetData(properties);
    actionsToUse = [
      { id: 'hide', icon: 'fa-solid fa-eye-slash', class: 'secondary', title: 'إخفاء' },
      { id: 'zoom', icon: 'fa-solid fa-magnifying-glass-plus', class: 'secondary', title: 'تكبير' }
    ];
  } else if (type === 'Urban') {
    sheetData = buildUrbanSheetData(properties); // We'll rename showUrbanInfo's logic to this
    actionsToUse = [
      { id: 'hide', icon: 'fa-solid fa-eye-slash', class: 'secondary', title: 'إخفاء' },
      { id: 'zoom', icon: 'fa-solid fa-magnifying-glass-plus', class: 'secondary', title: 'تكبير' }
    ];
  } else if (type === 'Imported') {
    sheetData = buildImportedSheetData(originalFeature); // We'll extract this logic
    actionsToUse = [
      { id: 'hide', icon: 'fa-solid fa-eye-slash', class: 'secondary', title: 'إخفاء' },
      { id: 'zoom', icon: 'fa-solid fa-magnifying-glass-plus', class: 'secondary', title: 'تكبير' }
    ];
  }

  if (!sheetData) return;

  // 2. Add Navigation Indicator (X of Y) to Subtitle
  const countLabel = identifiedFeatures.length > 1 
    ? ` <span style="color:var(--primary);font-weight:bold;margin-right:8px;">(${index + 1} من ${identifiedFeatures.length})</span>` 
    : '';
  sheetData.subtitle = (sheetData.subtitle || '') + countLabel;

  // 3. Add Navigation Arrows if multiple features
  if (identifiedFeatures.length > 1) {
    const navActions = [];
    
    // Previous Arrow (Back) - Right side in RTL
    navActions.push({ 
      id: 'prev_feature', 
      icon: 'fa-solid fa-arrow-right', 
      class: 'secondary nav-btn', 
      title: 'السابق' 
    });

    // Next Arrow (Forward) - Left side in RTL
    navActions.push({ 
      id: 'next_feature', 
      icon: 'fa-solid fa-arrow-left', 
      class: 'secondary nav-btn', 
      title: 'التالي' 
    });
    
    // Add navigation actions to the beginning or end
    actionsToUse = [...navActions, ...actionsToUse];
  }

  // 4. Update Map Highlight
  identifyidentifyHighlightSource.clear();
  if (window.topSearchidentifyHighlightSource) window.topSearchidentifyHighlightSource.clear();

  let featureObj = null;
  if (originalFeature) {
    // Clone to prevent 'Feature already added to another source' error
    featureObj = typeof originalFeature.clone === 'function' ? originalFeature.clone() : originalFeature;
    // Clear its custom style so it inherits the premium highlight style
    if (featureObj && typeof featureObj.setStyle === 'function') {
      featureObj.setStyle(null);
    }
  } else {
    featureObj = new GeoJSON().readFeature({ type: 'Feature', geometry, properties }, {
      dataProjection: projection,
      featureProjection: projection
    });
  }
  identifyidentifyHighlightSource.addFeature(featureObj);

  // 5. Update Globals for other tools (zoom, report)
  lastParcelFeature = featureObj;
  lastParcelCoord = coordinate;
  window._currentParcelData = { parcel: properties, feature: featureObj, coordinate };
  window._lastActiveSheetData = {
    data: sheetData,
    isUrban: type === 'Urban',
    isBuilding: type === 'Building',
    isNatural: type === 'NaturalBlock',
    isImported: type === 'Imported',
    coordinate: coordinate
  };

  // 6. Show Sheet
  featureSheet.clearCallbacks();
  setupIdentifyActions();
  featureSheet.show({ ...sheetData, actions: actionsToUse });

  ensureSidebarVisible();
  hideParcelInfoChip();
}

/**
 * Helper to build Urban Data (Extracted from showUrbanInfo)
 */
function buildUrbanSheetData(urban) {
  const landUse = urban.landuse_ar || urban.Landuse_ar || urban.landuse_Ar || '-';
  const status = urban.status_ara || urban.Status_ara || urban.status_Ara || '-';
  const community = urban.communityn || urban.Communityn || '-';
  const year = urban.approvalye || urban.Approvalye || '-';
  const gov = urban.governorat || urban.Governorat || '-';

  return {
    title: 'المخطط الهيكلي',
    subtitle: `${gov} - ${community}`,
    keyMetric: {
      label: 'تصنيف المخطط',
      value: landUse,
      icon: 'fa-info-circle',
      color: '#dc3545'
    },
    attributes: [
      { key: 'تصنيف المخطط', value: landUse },
      { key: 'الحالة', value: status },
      { key: 'التجمع', value: community },
      { key: 'سنة الإقرار', value: year },
      { key: 'المحافظة', value: gov },
    ].filter(attr => attr.value !== '-' && attr.value !== null)
  };
}

/**
 * Helper to build Imported Data (Extracted from showImportedFeatureInfo)
 */
function buildImportedSheetData(feature) {
  let props = feature.getProperties();
  const { geometry, ...attributes } = props;
  const displayAttrs = [];
  let featureTitle = 'تفاصيل العنصر';

  for (const [key, value] of Object.entries(attributes)) {
    if (key.startsWith('__') || key === '_original_style_' || !value || typeof value === 'object') continue;
    const lowerKey = key.toLowerCase();
    if (lowerKey === 'description' && String(value).includes('<table')) {
      const parsed = parseKMLDescriptionHTML(String(value));
      if (parsed.length > 0) { displayAttrs.push(...parsed); continue; }
    }
    const techKeys = ['styleurl', 'stylehash', 'stylemaphash', 'stroke', 'fill', 'marker', 'visibility', 'draworder', 'icon', 'snippet', 'handle', 'owner', 'layer', 'color'];
    if (techKeys.some(tk => lowerKey.includes(tk))) continue;
    if ((lowerKey === 'name' || lowerKey === 'title' || lowerKey === 'id' || lowerKey === 'label') && featureTitle === 'تفاصيل العنصر') {
      featureTitle = value;
    }
    displayAttrs.push({ key: key, value: String(value) });
  }

  return {
    title: featureTitle,
    subtitle: 'عنصر من ملف مرفوع',
    keyMetric: { label: 'عدد الخصائص', value: displayAttrs.length, icon: 'fa-layer-group', color: '#17a2b8' },
    attributes: displayAttrs
  };
}

// ✅ متغير لتتبع طلب البحث النشط
let currentIdentifyRequest = null;
let identifyTimeout = null;

// جعل currentIdentifyRequest متاحاً عالمياً لإلغاء الطلبات من خارج الملف
window.currentIdentifyRequest = null;

// ✅ دوال تفعيل/تعطيل الأداة (يتم استدعاؤها من map.html)

window.enableIdentifyTool = function () {
  window.GeoPST.state.isIdentifyEnabled = true;

  // على الهاتف، أغلق القائمة فور تفعيل الأداة ليتمكن المستخدم من النقر على الخريطة
  if (window.innerWidth <= 1024) {
    closeSidebarOnMobile();
  }

  // على سطح المكتب، افتح الشريط الجانبي وأظهر التعليمات
  if (window.innerWidth >= 1024) {
    document.body.classList.add('left-sidebar-open');
    // تحديث حجم الخريطة
    const map = window.olMap || window.map;
    if (map) setTimeout(() => map.updateSize(), 400);

    // إظهار حالة الجاهزية (Desktop only - prevents map overlap on mobile)
    featureSheet.clearCallbacks();
    setupIdentifyActions();
    featureSheet.showEmpty('أداة الاستعلام مفعلة');
    // تحديث المحتوى ليكون توجيهيًا
    setTimeout(() => {
      const contentEl = featureSheet.container?.querySelector('.bottom-sheet-content');
      if (contentEl) {
        const emptyEl = contentEl.querySelector('.bottom-sheet-empty');
        if (emptyEl) {
          const iconEl = emptyEl.querySelector('i');
          if (iconEl) iconEl.className = 'fas fa-hand-pointer';
          const descEl = emptyEl.querySelector('.bottom-sheet-empty-desc');
          if (descEl) descEl.textContent = 'انقر على أي قطعة أرض لعرض معلوماتها التفصيلية.';
        }
      }
    }, 50);
  }
};

window.disableIdentifyTool = function () {
  window.GeoPST.state.isIdentifyEnabled = false;

  // إغلاق الشريط الجانبي وتحديث الخريطة
  if (window.innerWidth >= 1024) {
    document.body.classList.remove('left-sidebar-open');
    const map = window.olMap || window.map;
    if (map) setTimeout(() => {
      if (map && typeof map.updateSize === 'function') map.updateSize();
    }, 400);
  }

  // ✅ تحديث حالة الزر في أدوات الأدوات لضمان المزامنة
  const $idBtn = $('#identifyToggleBtn');
  if ($idBtn.length) $idBtn.removeClass('active');

  // تنظيف كل شيء
  window.closeParcelPopup();
};

// ✅ Cache بسيط للنتائج الأخيرة لتقليل الطلبات المتكررة (اختياري - غير مستخدم حالياً لتجنب التعقيد)
// يمكن تفعيله لاحقاً إذا لزم الأمر

// ✅ تتبع الطلبات النشطة للإلغاء
let activeXHRs = [];

function abortActiveRequests() {
  activeXHRs.forEach(xhr => {
    if (xhr && xhr.readyState !== 4) xhr.abort();
  });
  activeXHRs = [];
}

// عند النقر على الخريطة
map.on('singleclick', function (evt) {
  if (window.GeoPST.state.isMeasuring || window.GeoPST.state.isDrawing || !window.GeoPST.state.isIdentifyEnabled) return;

  // ⚡ إلغاء أي طلبات سابقة لتسريع الاستجابة ومنع تضارب البيانات
  abortActiveRequests();
  
  // مسح أي تلوين سابق من البحث العلوي
  if (window.topSearchidentifyHighlightSource) window.topSearchidentifyHighlightSource.clear();

  // ⚡ إيقاف المتابعة التلقائية للسماح للمستخدم بالتركيز على النقطة التي نقر عليها
  if (window.GeoPST_Geolocation && typeof window.GeoPST_Geolocation.stopFollowing === 'function') {
    window.GeoPST_Geolocation.stopFollowing();
  }

  const coordinate = evt.coordinate;
  const view = map.getView();
  const resolution = view.getResolution();
  const projection = view.getProjection();

  // ⚡ لا نمسح التحديد ولا الزر العائم إلا إذا كنا متأكدين أننا سنعرض بيانات جديدة
  // hideParcelInfoChip(); 

  ensureSidebarVisible(); // ⚡ ضمان توسعة المساحة قبل العرض
  featureSheet.showLoading();

  // ==========================================
  // NEW LOGIC: Check Imported Vector Features
  // ==========================================
  let importedFeaturesArray = map.getFeaturesAtPixel(evt.pixel, { 
    hitTolerance: 6,
    layerFilter: (l) => {
      if (!l || typeof l.get !== 'function') return false;
      const name = l.get('name');
      return name && String(name).startsWith('Import_') && l.getVisible();
    }
  }) || [];

  const requests = [];

  // 1. Parcel Request
  const ParcelLayer = getlayerByName('Parcel');
  if (ParcelLayer && ParcelLayer.getVisible()) {
    const url = ParcelLayer.getSource().getFeatureInfoUrl(coordinate, resolution, projection, { 
      INFO_FORMAT: 'application/json', 
      FEATURE_COUNT: 1 
    });
    if (url) {
      // 🚨 Security Patch: Rewrite external URL to local secure proxy
      const secureUrl = url.replace(GEOSERVER_EXTERNAL_URL, GEOSERVER_BASE_URL);
      
      const fetchFn = window.secureFetch || fetch;
      requests.push(
        fetchFn(secureUrl, { method: 'GET' })
          .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
          .then(data => ({ type: 'Parcel', data }))
          .catch(err => ({ type: 'Parcel', err }))
      );
    }
  }

  // 2. Urban Master Request
  const UrbanLayer = getlayerByName('UrbanMaster_2025');
  if (UrbanLayer && UrbanLayer.getVisible()) {
    const url = UrbanLayer.getSource().getFeatureInfoUrl(coordinate, resolution, projection, { 
      INFO_FORMAT: 'application/json', 
      FEATURE_COUNT: 1 
    });
    if (url) {
      // 🚨 Security Patch: Rewrite external URL to local secure proxy
      const secureUrl = url.replace(GEOSERVER_EXTERNAL_URL, GEOSERVER_BASE_URL);

      const fetchFn = window.secureFetch || fetch;
      requests.push(
        fetchFn(secureUrl, { method: 'GET' })
          .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
          .then(data => ({ type: 'Urban', data }))
          .catch(err => ({ type: 'Urban', err }))
      );
    }
  }

  // 3. Natural Blocks Request
  const BlocksLayer = getlayerByName('Blocks_Non_Registered');
  if (BlocksLayer && BlocksLayer.getVisible()) {
    const url = BlocksLayer.getSource().getFeatureInfoUrl(coordinate, resolution, projection, { 
      INFO_FORMAT: 'application/json', 
      FEATURE_COUNT: 1 
    });
    if (url) {
      const secureUrl = url.replace(GEOSERVER_EXTERNAL_URL, GEOSERVER_BASE_URL);
      const fetchFn = window.secureFetch || fetch;
      requests.push(
        fetchFn(secureUrl, { method: 'GET' })
          .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
          .then(data => ({ type: 'NaturalBlock', data }))
          .catch(err => ({ type: 'NaturalBlock', err }))
      );
    }
  }

  // 4. Buildings Request
  const BuildingLayer = getlayerByName('Buildings');
  if (BuildingLayer && BuildingLayer.getVisible()) {
    const url = BuildingLayer.getSource().getFeatureInfoUrl(coordinate, resolution, projection, { 
      INFO_FORMAT: 'application/json', 
      FEATURE_COUNT: 1 
    });
    if (url) {
      const secureUrl = url.replace(GEOSERVER_EXTERNAL_URL, GEOSERVER_BASE_URL);
      const fetchFn = window.secureFetch || fetch;
      requests.push(
        fetchFn(secureUrl, { method: 'GET' })
          .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
          .then(data => ({ type: 'Building', data }))
          .catch(err => ({ type: 'Building', err }))
      );
    }
  }

  if (requests.length === 0 && importedFeaturesArray.length === 0) {
    ensureSidebarVisible();
    featureSheet.showEmpty('لا توجد طبقات مفعلة للاستعلام');
    return;
  }

  // Execute requests
  Promise.all(requests).then(results => {
    activeXHRs = [];
    identifiedFeatures = [];

    // Prioritize results manually
    const parcelResults = results.filter(r => r.type === 'Parcel' && r.data?.features?.length > 0);
    const buildingResults = results.filter(r => r.type === 'Building' && r.data?.features?.length > 0);
    const naturalResults = results.filter(r => r.type === 'NaturalBlock' && r.data?.features?.length > 0);
    const urbanResults = results.filter(r => r.type === 'Urban' && r.data?.features?.length > 0);

    // 1. Add Parcels
    parcelResults.forEach(r => {
      r.data.features.forEach(f => {
        identifiedFeatures.push({ type: 'Parcel', properties: f.properties, geometry: f.geometry, coordinate, projection });
      });
    });

    // 2. Add Buildings
    buildingResults.forEach(r => {
      r.data.features.forEach(f => {
        identifiedFeatures.push({ type: 'Building', properties: f.properties, geometry: f.geometry, coordinate, projection });
      });
    });

    // 3. Add Natural Blocks
    naturalResults.forEach(r => {
      r.data.features.forEach(f => {
        identifiedFeatures.push({ type: 'NaturalBlock', properties: f.properties, geometry: f.geometry, coordinate, projection });
      });
    });

    // 3. Add Urban
    urbanResults.forEach(r => {
      r.data.features.forEach(f => {
        identifiedFeatures.push({ type: 'Urban', properties: f.properties, geometry: f.geometry, coordinate, projection });
      });
    });

    // 4. Add Imported Vector Features (Top priority for visual feedback, but standard priority below)
    if (importedFeaturesArray.length > 0) {
      const uniqueImported = [...new Set(importedFeaturesArray)];
      uniqueImported.forEach(feat => {
        identifiedFeatures.push({ type: 'Imported', originalFeature: feat, coordinate, projection });
      });
    }

    if (identifiedFeatures.length === 0) {
      identifyidentifyHighlightSource.clear();
      ensureSidebarVisible();
      featureSheet.showEmpty('لم يتم العثور على بيانات في هذا الموقع');
      lastParcelFeature = null;
      lastParcelCoord = null;
      window._currentParcelData = null;
      return;
    }

    // Start with the first feature
    showIdentifiedFeature(0);

  }).catch(e => {
    console.error(e);
    featureSheet.showEmpty('خطأ في جلب البيانات');
  });
});

// زر الإخفاء داخل الـpopup
function wireHideButtonInsidePopup() {
  // إعادة ربط زر الإخفاء
  const hideBtn = document.getElementById('parcelHideBtn');
  if (hideBtn) {
    hideBtn.onclick = (e) => {
      e.stopPropagation();
      hideParcelInfo();
    };
  }

  // إعادة ربط زر الإغلاق (X)
  const closeBtn = document.getElementById('popupCloseHeaderBtn');
  if (closeBtn) {
    closeBtn.onclick = (e) => {
      e.stopPropagation();
      window.closeParcelPopup();
      return false;
    };
  }

  // إعادة ربط زر مشاهدة الشارع (Street View)
  const svBtn = document.getElementById('streetViewBtn');
  if (svBtn) {
    svBtn.onclick = (e) => {
      e.stopPropagation();
      if (lastParcelCoord) openStreetView(lastParcelCoord);
    };
  }
}

// ✅ إضافة دالة عامة لإغلاق الـ popup من الخارج (إغلاق كامل)
window.closeParcelPopup = function () {
  identifyidentifyHighlightSource.clear();
  if (window.featureSheet) window.featureSheet.hide(); // تأكيد إخفاء الـ Sheet

  lastParcelHTML = '';
  lastParcelCoord = null;
  lastParcelFeature = null;
  hideParcelInfoChip();

  // ⚡ FIX: Restore Desktop Layout - Expand map back to full width
  if (window.innerWidth >= 1024) {
    document.body.classList.remove('left-sidebar-open');
    const map = window.olMap || window.map;
    if (map) setTimeout(() => map.updateSize(), 400);
  }
};


// ✅ مراقبة تغيير حالة طبقة Parcel بدون setTimeout
(function watchParcelLayerVisibility() {
  const parcelLayer = getlayerByName('Parcel');
  if (parcelLayer) {
    parcelLayer.on('change:visible', function () {
      if (!parcelLayer.getVisible()) {
        window.closeParcelPopup(); // إغلاق تام عند إخفاء الطبقة
      }
    });
  } else {
    // إذا لم تكن الطبقة موجودة بعد، انتظر حدث تحميل الخريطة
    map.once('rendercomplete', () => {
      const layer = getlayerByName('Parcel');
      if (layer) {
        layer.on('change:visible', function () {
          if (!layer.getVisible()) {
            window.closeParcelPopup();
          }
        });
      }
    });
  }
})();


// ✅ دالة فتح الستريت فيو (النسخة النهائية النظيفة)
window.openStreetView = function (coordinate) {
  if (!coordinate) return;

  try {
    const lonLat = toLonLat(coordinate, map.getView().getProjection());
    const lon = lonLat[0];
    const lat = lonLat[1];

    // الرابط الرسمي والمباشر من جوجل بدون أي أرقام عشوائية بتخرب الإحداثيات
    const url = `https://maps.google.com/maps?layer=c&cbll=${lat},${lon}&cbp=11,0,0,0,0&output=svembed`;

    $('#streetViewFrame')
      .attr('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture')
      .attr('src', url);

    $('#streetViewModal').fadeIn(300).css('display', 'flex');

  } catch (e) {
    console.error('Error opening Street View:', e);
    window.showErrorModal('حدث خطأ أثناء فتح مشاهدة الشارع');
  }
};
/**
 * ⚡ FIX: Intercept global closeStreetView to unlock the sheet
 * (تم إرجاعها كما كانت في الملف القديم)
 */
const originalCloseStreetView = window.closeStreetView;
window.closeStreetView = function () {
  if (typeof originalCloseStreetView === 'function') {
    originalCloseStreetView();
  }
  if (window.featureSheet) {
    window.featureSheet.setLocked(false);
  }
};


/**
 * دالة مساعدة لتحليل جداول الـ HTML التي قد تتواجد في وصف ملفات الكي إم إل (KML)
 * @param {string} html - نص الـ HTML من خاصية description
 * @returns {Array} - مجموعة من الخصائص المفلترة
 */
function parseKMLDescriptionHTML(html) {
  if (!html || typeof html !== 'string') return [];
  if (!html.includes('<table') && !html.includes('<tr')) return [];

  const results = [];
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const rows = doc.querySelectorAll('tr');

    rows.forEach(row => {
      const cells = row.querySelectorAll('td');
      if (cells.length >= 2) {
        // غالباً الخلية الأولى هي المفتاح والثانية هي القيمة
        let key = cells[0].textContent.replace(':', '').trim();
        let value = cells[1].textContent.trim();

        if (key && value && value !== 'null' && value !== 'undefined') {
          results.push({ key, value });
        }
      } else if (cells.length === 1) {
        // حالة خلية واحدة قد تحتوي على نص مدمج
        const text = cells[0].textContent.trim();
        if (text.includes(':')) {
          const parts = text.split(':');
          results.push({ key: parts[0].trim(), value: parts.slice(1).join(':').trim() });
        }
      }
    });
  } catch (e) {
    console.warn("Failed to parse KML HTML description:", e);
  }
  return results;
}


// ✅ إعداد إجراءات الـ BottomSheet
function setupIdentifyActions() {
  // Navigation: Next Feature
  featureSheet.onAction('next_feature', () => {
    if (currentFeatureIndex < identifiedFeatures.length - 1) {
      showIdentifiedFeature(currentFeatureIndex + 1);
    } else {
      // Loop back to start
      showIdentifiedFeature(0);
    }
  });

  // Navigation: Previous Feature
  featureSheet.onAction('prev_feature', () => {
    if (currentFeatureIndex > 0) {
      showIdentifiedFeature(currentFeatureIndex - 1);
    } else {
      // Loop to end
      showIdentifiedFeature(identifiedFeatures.length - 1);
    }
  });

  // Street View Button
  featureSheet.onAction('streetview', () => {
    const data = window._currentParcelData; // Using same global for simplicity
    if (!data || !data.coordinate) return;

    featureSheet.setLocked(true); // ⚡ Lock UI
    window.openStreetView(data.coordinate);
  });

  // Report JPG Button
  featureSheet.onAction('report', async () => {
    const data = window._currentParcelData;
    if (!data || !data.parcel) return;

    // Report only applies to Parcels
    featureSheet.setButtonLoading('report', true);
    featureSheet.setLocked(true); // ⚡ Lock UI during export
    try {
      if (typeof generateParcelReport === 'function') {
        await generateParcelReport(data.parcel, data.feature);
      } else if (typeof window.generateParcelReport === 'function') {
        await window.generateParcelReport(data.parcel, data.feature);
      }
    } catch (err) {
      console.error("Report generation failed:", err);
    } finally {
      featureSheet.setButtonLoading('report', false);
      featureSheet.setLocked(false); // ⚡ Unlock UI
    }
  });

  // Zoom Button
  featureSheet.onAction('zoom', () => {
    // Try to get the highlighted feature extent
    const features = identifyidentifyHighlightSource.getFeatures();
    if (features && features.length > 0) {
      const geometry = features[0].getGeometry();
      if (geometry) {
        const extent = geometry.getExtent();
        const isMobile = window.innerWidth < 1024;
        const bottomPadding = isMobile ? 380 : 250;
        map.getView().fit(extent, {
          padding: [100, 100, bottomPadding, 100],
          duration: 500,
          maxZoom: 11
        });
        return;
      }
    }
    // Fallback
    const data = window._currentParcelData;
    if (data && data.coordinate) {
      map.getView().animate({ center: data.coordinate, zoom: 11, duration: 400 });
    }
  });

  // Hide Button
  featureSheet.onAction('hide', () => {
    featureSheet.hide();
    if (window.innerWidth >= 1024) {
      document.body.classList.remove('left-sidebar-open');
      if (map) setTimeout(() => map.updateSize(), 400);
    }
    showParcelInfoChip();
  });


  // Close Button - Now closes results AND deactivates tool
  featureSheet.onAction('close', () => {
    window.closeParcelPopup();
  });
}

// Initial setup
setupIdentifyActions();

/**
 * ⚡ FIX: Intercept global closeStreetView to unlock the sheet
 */
/**
 * دالة إغلاق مشاهدة الشارع - مركزية لضمان تنظيف الذاكرة وإلغاء قفل الواجهة
 */
window.closeStreetView = function () {
  const modal = document.getElementById('streetViewModal');
  const frame = document.getElementById('streetViewFrame');

  if (modal) {
    $(modal).fadeOut(300);
  }

  if (frame) {
    // إفراغ الـ src لضمان توقف الصوت/الفيديو وتوفير الموارد
    frame.src = '';
  }

  // ✅ إلغاء قفل الـ BottomSheet عند العودة من مشاهدة الشارع
  if (window.featureSheet) {
    window.featureSheet.setLocked(false);
  }

  // السماح للعدسة بالظهور مرة أخرى
  window.magnifierSuppressed = false;
};

// ✅ ربط زر التحديد (Identify) - تم نقله من الـ HTML لضمان التنسيق
$(document).ready(() => {
  const $idBtn = $('#identifyToggleBtn');
  if ($idBtn.length) {
    $idBtn.on('click', (e) => {
      e.stopPropagation();
      const wasEnabled = window.GeoPST.state.isIdentifyEnabled;
      if (!wasEnabled) {
        window.enableIdentifyTool();
        $idBtn.addClass('active');
      } else {
        window.disableIdentifyTool();
        $idBtn.removeClass('active');
      }
    });
  }
});
